import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { capitalizeStage } from 'components/featured/Deals/components/DealDetailsMain/utils';
import { Status } from 'model/alerts.model';
import { apiDealTypes } from 'model/deals.model';
import { DealsService } from 'service/deals.service';

export type OptionType = { value: string; label: string };

interface DealsState {
  stage: string;
  owner: string;
  owners: any[];
  formattedOwners: OptionType[];
  stages: OptionType[];
  deal: any;
  loading: Status;
}

const initialState: DealsState = {
  stage: '',
  owner: '',
  owners: [],
  stages: [],
  formattedOwners: [],
  deal: {},
  loading: 'idle',
};

export const fetchDealById = createAsyncThunk('deals/fetchDealById', async (id: string) => {
  const data = await DealsService.getDealById(id);
  return data.data;
});

export const updateDeal = createAsyncThunk('deals/fetchDealById', async (id: string, payload) => {
  await DealsService.updateDeal(id, payload);
});

export const fetchOwners = createAsyncThunk('deals/fetchOwners', async () => {
  const data = await DealsService.getMembers();
  return data;
});

export const fetchStages = createAsyncThunk('deals/fetchStages', async (dealType: apiDealTypes) => {
  const dropdownsData = await DealsService.getDealDropdowns(dealType);

  const stages = dropdownsData.stages.map((stage: any) => {
    return {
      value: stage.stageName,
      label: capitalizeStage(stage.stageName),
    };
  });
  return stages;
});

const dealsSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {
    setStage: (state, action) => {
      state.stage = action.payload;
    },
    setOwner: (state, action) => {
      state.owner = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchOwners.fulfilled, (state, action) => {
      state.owners = action.payload;
      state.formattedOwners = action.payload
        .map((item: any) => ({
          value: item.email || '',
          label: `${item.firstName} ${item.lastName}` || '',
        }))
        .filter((item: any) => item.value && item.label);
    });
    builder.addCase(fetchStages.fulfilled, (state, action) => {
      state.stages = action.payload;
    });
    builder.addCase(fetchDealById.fulfilled, (state, action) => {
      state.deal = action.payload;
      state.loading = 'complete';
    });
    builder.addCase(fetchDealById.pending, (state, action) => {
      state.loading = 'in-progress';
    });
  },
});

export const { setStage, setOwner } = dealsSlice.actions;
export default dealsSlice.reducer;
